// extracted by mini-css-extract-plugin
export default {"primary":"#2b59db","secondary":"#ffaab8","text":"#565a5e"};